module.exports = __webpack_public_path__ + "img/IMG_20180408_154653.06da4f9e.jpg";